export default "__VITE_ASSET__RAZIcwVH__"